import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-modal-erro-coletor',
  templateUrl: './modal-erro-coletor.component.html',
  styleUrls: ['./modal-erro-coletor.component.scss']
})
export class ModalErroColetorComponent implements OnInit {

  

  titulo = "Erro";
  
  tempoDefault = 3000;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    private dialog: MatDialogRef<ModalErroColetorComponent>
  ) {
    
  }

  ngOnInit() {
    this.tempoDefault = this.data.tempo != null ? this.data.tempo : this.tempoDefault;
    window.setTimeout(() => {
      this.dialog.close();
    }, this.tempoDefault)
    
   
   }

}
